import { Account } from "../Model/Account";
export class AccountsFactory {
    createAccount(id, enabled, name, allowedTypes) {
        return new Account(id, enabled, name, allowedTypes);
    }
}
